import { FC, SVGProps } from "react";

const SvgIcon: FC<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 24 24" width={20} height={20} fill="currentColor" aria-hidden {...props} />
);

export const BandConstructionIcon: FC = () => (
  <SvgIcon>
    <path d="M7 5h8v14H7z" fill="#3f6db5" opacity={0.18} />
    <path
      d="M3 16c1.6-4.5 2.4-4.5 4 0s2.4 4.5 4 0 2.4-4.5 4 0 2.4 4.5 4 0 2.2-4.5 3-4.5"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeLinejoin="round"
    />
    <path d="M7 4v16" fill="none" stroke="#2e7d32" strokeWidth={1.7} />
    <path d="M15 4v16" fill="none" stroke="#f44336" strokeWidth={1.7} />
  </SvgIcon>
);

export const RevolutionConstructionIcon: FC = () => (
  <SvgIcon>
    <path d="M8 6h6v12H8z" fill="#3f6db5" opacity={0.22} />
    <path
      d="M3 16c1.2-3.2 1.8-3.2 3 0s1.8 3.2 3 0 1.8-3.2 3 0 1.8 3.2 3 0 1.8-3.2 3 0 1.6-3.2 2.2-3.2"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.3}
      strokeLinejoin="round"
    />
    <path d="M5 5v14M8 5v14M14 5v14M17 5v14M20 5v14" fill="none" stroke="#2e7d32" strokeWidth={1.2} />
    <path d="M11 4v16" fill="none" stroke="#f44336" strokeWidth={1.6} />
  </SvgIcon>
);

export const OrbitOverlayIcon: FC = () => (
  <SvgIcon>
    <ellipse cx="9.2" cy="12" rx="5.2" ry="3.6" fill="none" stroke="currentColor" strokeWidth="1.6" />
    <ellipse cx="14.8" cy="12" rx="5.2" ry="3.6" fill="none" stroke="currentColor" strokeWidth="1.6" />
  </SvgIcon>
);
